import { CountValue } from "@happy-legal/graphql-types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from "@mui/material";
import React, { useContext, useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import HLTextField from "../../../shared/components/Form/HLTextField";
import { hasDirtyFields } from "../../../shared/helpers/hasDirtyFields";
import { CountContext } from "../../../shared/providers/CountProvider";
import { SET_COUNT } from "../../../shared/reducer";

const CountEditorDialog = ({
  configDataKey,
  handleCloseDialog,
}: {
  configDataKey: string;
  handleCloseDialog: () => void;
}) => {
  const { state, dispatch } = useContext(CountContext);

  const methods = useForm({ defaultValues: state?.countValue });
  const {
    formState: { isSubmitSuccessful },
  } = methods;

  const handleSubmit = async (formData: CountValue) =>
    dispatch({ type: SET_COUNT, key: configDataKey, payload: formData });

  // Bypass memory leak cause by not consitently mounting dialog
  useEffect(() => {
    if (!isSubmitSuccessful) return;
    handleCloseDialog();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSubmitSuccessful]);

  return (
    <Dialog open onClose={handleCloseDialog}>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(handleSubmit)}>
          <DialogContent>
            <HLTextField
              name="total"
              label="Total"
              type="number"
              margin="normal"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog} color="primary">
              Abbrechen
            </Button>
            <Button
              type="submit"
              color="primary"
              disabled={!hasDirtyFields(methods)}
            >
              Speichern
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </Dialog>
  );
};

export default CountEditorDialog;
